module.exports = __webpack_public_path__ + "static/img/swiperitem02.93962502.jpg";